module.exports = __webpack_public_path__ + "static/logo-jaguar.b31061ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-jaguar.png
// module id = 409
// module chunks = 114276838955818